"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
const lodash_1 = __importDefault(require("lodash"));
const utilities_1 = require("../../utilities");
exports.default = _ref => {
  let {
    type,
    values,
    customDomain = [undefined, undefined],
    customTicks = undefined
  } = _ref;
  const axisType = 'y';
  const domain = [lodash_1.default.min([...values, 0]), lodash_1.default.max([...values, 0])];
  let newDomain = (0, utilities_1.parseDomain)(domain, []);
  let newTicks;
  if (customDomain) {
    const parsedDomain = (0, utilities_1.formatAxisData)(axisType, type, customDomain);
    newDomain = (0, utilities_1.parseDomain)(parsedDomain, domain);
  }
  let scale = (0, utilities_1.calculateScale)(type, newDomain);
  if (customTicks) {
    newTicks = (0, utilities_1.formatAxisData)(axisType, type, customTicks);
    // extend domain to include custom ticks
    if (customDomain[0] === undefined && customDomain[1] === undefined) {
      newDomain = [Math.min(domain[0], newTicks[0]), Math.max(domain[1], newTicks[newTicks.length - 1])];
      scale = (0, utilities_1.calculateScale)(type, newDomain);
    } else {
      // remove out of bounds ticks
      newTicks = newTicks.filter(nt => nt >= newDomain[0] && nt <= newDomain[1]);
    }
  }
  newTicks = (0, utilities_1.getAxisTicks)({
    axisType,
    scale,
    customTicks: newTicks
  });
  return {
    domain: newDomain,
    ticks: newTicks,
    scale: scale.nice()
  };
};